var searchTagMap = {
  featured: 'featured',
  id: 'id',
  image_url: 'imageUrl',
  name: 'name',
  type: 'type',
  weight: 'weight',
  description: 'description'
};
export default searchTagMap;